import { useRouter } from "next/router";

import VideosList from "../../components/videos/videos-list";
import usePaginatedVideoSermons from "../../hooks/sermons/use-paginated-video-sermons";
import usePaginatedVideos from "../../hooks/videos/use-paginated-videos";
import { CategoryType, EventType } from "../../context/analytics-context";
import { useEffect } from "react";
import usePageEvents from "../../hooks/use-page-events";
import HeadMeta from "../../components/HeadMeta";

export default function Videos() {
  const router = useRouter();
  const videosQuery = usePaginatedVideos();
  const videoSermonsQuery = usePaginatedVideoSermons();
  const { type: videoType } = router.query;

  const sendAnalytics = usePageEvents(videoType as string, false);

  const getVideos = () => {
    if (videoType === "new-sermons") return videoSermonsQuery.data;
    return videosQuery.data;
  };

  const goBack = () => {
    router.back(); // || router.push("/discover");
  };

  useEffect(() => {
    if (videoType) {
      sendAnalytics({
        category: CategoryType.PAGE,
        type: EventType.PAGELOAD,
        page: videoType
      });
    }
  }, [videoType]);

  const getTitle = () => {
    switch (videoType) {
      case "liked":
        return "Liked Videos";

      case "new-music":
        return "New Music Videos";

      case "new-sermons":
        return "New Sermon Videos";

      default:
        return "Videos";
    }
  };

  return (
    <div className="w-full">
      <HeadMeta title={getTitle()} url={`/${videoType}`} />

      <div className="py-4">
        <div className="flex items-center px-3">
          <button onClick={goBack} className="flex items-center space-x-2">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="w-6 h-6"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M15 19l-7-7 7-7"
              />
            </svg>
            <p className="font-bold ">Back</p>
          </button>
        </div>

        <div className="px-3 mt-5">
          <p className="flex-1 text-4xl font-bold text-gray-800">{getTitle()}</p>

          <div className="mt-4">
            <form action="">
              <input
                type="text"
                name=""
                id=""
                placeholder="Search Videos"
                className="w-full px-6 py-3 text-white placeholder-white bg-gray-900 rounded-full"
              />
            </form>
          </div>
        </div>

        <div className="px-3 mt-1">
          <VideosList videos={getVideos()} isLoading={videosQuery.isLoading} />
        </div>
      </div>
    </div>
  );
}
